const textMorph = (element, start, end) => {
  const CHARS     = [''];
  const DURATION  = 0.3;
  const FRAME_RATE = 60;
  const STRING = start.split('');
  const RESULT = end.split('');
  const STRING_LENGTH   = STRING.length;
  const RESULT_LENGTH   = RESULT.length;
  let present   = new Date();
  let past      = present.getTime();
  let count     = 0;
  let spentTime = 0;
  let splitTime = (DURATION * 1000) / Math.max(STRING_LENGTH, RESULT_LENGTH);

  const update = () => {
    present = new Date();
    spentTime += present.getTime() - past;

    for (let i = count; i < Math.max(STRING_LENGTH, RESULT_LENGTH); i++) {
      const random = Math.floor(Math.random() * (CHARS.length - 1));
      STRING[i] = CHARS[random];
    }

    if (spentTime >= splitTime) {
      count += Math.floor(spentTime / splitTime);

      for (let j = 0; j < count; j++) {
        STRING[j] = RESULT[j] || null;
      }

      spentTime = 0;
    }

    element.textContent = STRING.join('');
    past = present.getTime();

    if (count < Math.max(STRING_LENGTH, RESULT_LENGTH)) {
      setTimeout(() => {
        window.requestAnimationFrame(update);
      }, 1000 / FRAME_RATE);
    }
  };

  update();
}

export default textMorph;